import styled from 'styled-components';
import { MentionAvatar } from 'common/ui/MentionAvatar';
import CircularProgress from '@mui/material/CircularProgress';
import Check from '@mui/icons-material/Check';
import Close from '@mui/icons-material/Close';
import { Colors, TextCss } from 'styles';

export const SettingsCard = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${Colors.gray3};
  text-align: initial;
  overflow: hidden;
  height: 100%;
`;

export const SettingsCardHeader = styled.div`
  padding: 1rem 3rem;
`;

export const SettingsCardContent = styled.div`
  padding: 1.5rem 3rem;
  overflow: auto;
  min-height: 0;
`;

export const SettingsLabel = styled.label`
  display: block;
  margin-left: 1.5rem;
  margin-bottom: 0.2rem;
  ${TextCss.caption}
`;

export const SettingsAvatar = styled(MentionAvatar)`
  background-color: ${Colors.blue1};
  width: 6rem;
  height: 6rem;
  margin-top: 1rem;
  ${TextCss.display2}
`;

export const SettingsSeparator = styled.hr`
  border: none;
  border-bottom: 1px solid ${Colors.gray6};
  margin: 2rem 0;
`;

export const SettingsSuccessIcon = styled(Check)`
  color: ${Colors.green5};
`;

export const SettingsErrorIcon = styled(Close)`
  color: ${Colors.red5};
`;

export const SettingsProgressSpinner = styled(CircularProgress)`
  color: ${Colors.blue4};
`;
